import React from 'react';
import WikiListItem from './wiki_list_item';

const WikiList = (props) => {
  if (props.wikis.length === 0) {
    return <div className="spinner"><i className="fa fa-spinner fa-spin"></i> Type something in the search bar.</div>;
  }
  const wikiItems = props.wikis.map((wiki) => {
    return (
      <WikiListItem
        key={wiki.pageid}
        wiki={wiki}/>
    );
  });

  return (
    <div className="col-md-12">
      <ul className="list-group">
        {wikiItems}
      </ul>
    </div>
  );
};

export default WikiList;


// WEBPACK FOOTER //
// ./src/components/wiki_list.js